import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { toast } from 'sonner';

export function useOAuthFeedback() {
  const tSocial = useTranslations('auth.social');
  const searchParams = useSearchParams();

  useEffect(() => {
    const oauthError = searchParams.get('oauth_error');

    if (oauthError === 'cancelled') {
      toast.error(tSocial('cancelled'));
      return;
    }
    if (oauthError === 'state_mismatch') {
      toast.error(tSocial('state_mismatch'));
      return;
    }
    if (oauthError === 'server_error') {
      toast.error(tSocial('server_error'));
    }
  }, [searchParams, tSocial]);
}
